var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"text-lg focus:outline-none font-medium py-3 px-4 rounded disabled:opacity-50",class:{
    // 'bg-green-400': this.variant === 'primary' && this.success,
    // 'bg-red-400': this.variant === 'primary' && this.danger,
    // 'bg-blue-400': this.variant === 'primary' && !this.success && !this.danger,
    'shadow-lg text-gray-900': this.variant === 'primary',

    // 'border-green-400 text-green-400': this.variant === 'secondary' && this.success,
    // 'border-red-400 text-red-400': this.variant === 'secondary' && this.danger,
    // 'border-blue-400 text-blue-400': this.variant === 'secondary' && !this.success && !this.danger,
    'bg-transparent border-2 border-solid': this.variant === 'secondary',
  }},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }